import axios from 'axios';
import {
  BASE_URL
} from "../../config/env";

export const orderBaseUrl = BASE_URL.TEST_HOST_API;

//获取所有云盘商品信息
export const getpkpmgoods = (params) => {
  let reqUrl='/api/v1/Goods/GetGoodsList?pageIndex=1&pageSize=1000'
  return axios({
    method: 'get',
    url: orderBaseUrl + reqUrl,
  })
}


//订单详情
export const orderDetailApi=(params)=>{
  return axios({
    method: 'get',
    url: orderBaseUrl + `/api/v1/Order/OrderDetail/userId/${params.userId}/orderNo/${params.orderNo}`,
  })
}

//获取验证码
export const getVerifyCodeApi=(params)=>{
  return axios({
    method: 'post',
    url: orderBaseUrl + `/api/v1/User/verifyMobile`,
    data:params
  })
}

//注销个人账户接口
export const CancelPersonalAccountApi=(data)=>{
  return axios({
    method: 'post',
    url: orderBaseUrl + `/api/v1/User/CancelPersonalAccount`,
    data:data
  })
}

//预注销个人账户 反馈个人不能注销的原因
export const PreCancelPersonalAccountApi=(data)=>{
  return axios({
    method: 'post',
    url: orderBaseUrl + `/api/v1/User/PreCancelPersonalAccount`,
    data:data
  })
}


//手机号绑定
export const changeMobileApi=(params)=>{
  return axios({
    method: 'put',
    url: orderBaseUrl + `/api/v1/User/ChangeMobile?oldMobile=${params.oldMobile}`,
    data:{
      bindType:'sms',
      password:params.password,
      principal:params.principal,
      code:params.code
    }
  })
}







// WEBPACK FOOTER //
// ./src/js/orderApi.js